import { Scale } from "lucide-react";
import { scrollToForm } from "./Shared";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#FBF9F5]">
    <div className="mx-auto max-w-7xl px-5 sm:px-10 lg:px-16 py-14">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center border border-[#1A1715] rounded-sm">
              <Scale className="h-4 w-4" strokeWidth={1.75} />
            </span>
            <span className="font-serif font-semibold text-lg text-[#1A1715]">
              Lawsuit Settlement Help
            </span>
          </div>
          <p className="mt-4 font-sans text-xs text-[#78716C] leading-relaxed">
            A consumer legal intake service connecting individuals with
            independent legal professionals. We are not a law firm and do not
            provide legal advice.
          </p>
        </div>
        <nav className="flex flex-col gap-3" aria-label="Legal">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#78716C]">
            Legal
          </span>
          <a
            href="/privacy-policy"
            data-testid="footer-privacy-link"
            className="font-sans text-sm font-medium text-[#44403C] hover:text-[#C2410C] transition-colors"
          >
            Privacy Policy
          </a>
          <a
            href="/terms-of-use"
            data-testid="footer-terms-link"
            className="font-sans text-sm font-medium text-[#44403C] hover:text-[#C2410C] transition-colors"
          >
            Terms of Use
          </a>
          <a
            href="/disclaimer"
            data-testid="footer-disclaimer-link"
            className="font-sans text-sm font-medium text-[#44403C] hover:text-[#C2410C] transition-colors"
          >
            Disclaimer
          </a>
          <button
            type="button"
            data-testid="footer-cta-button"
            onClick={scrollToForm}
            className="text-left font-sans text-sm font-medium text-[#44403C] hover:text-[#C2410C] transition-colors"
          >
            Free Case Review
          </button>
        </nav>
      </div>

      <div className="mt-12 border-t border-[#E7E2DA] pt-8">
        <p className="font-sans text-[11px] leading-relaxed text-[#A8A29E]">
          ATTORNEY ADVERTISING NOTICE: This website is a paid advertisement
          for legal services operated by Lawsuit Settlement Help, a non-attorney
          marketing service. Lawsuit Settlement Help is not a law firm or lawyer
          referral service and does not provide legal advice or legal
          representation. Submitting information through this website does not
          create an attorney-client relationship. Participating law firms vary
          by campaign and are subject to change without notice. Prior results
          do not guarantee a similar outcome. No representation is made that
          the quality of legal services to be performed is greater than the
          quality of legal services performed by other lawyers. Please review
          our Disclaimer, Terms of Use, and Privacy Policy.
        </p>
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.18em] text-[#A8A29E]">
          © {new Date().getFullYear()} Lawsuit Settlement Help · All rights reserved
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
